const state = {
  detailParam: {},
};

export default {
  namespaced: true,
  state,
  actions: {
    clearDetailParam({ commit }) {
      commit("SET_DETAIL_PARAM", {});
    },
    // 1260에서 던진 것을 받아서 mutation에게 전달
    openDetailUserCommute({ commit }, params) {
      commit("SET_DETAIL_PARAM", params);
    },
  },
  /* airsim comments 2026.04.29 위의 로직으로 수정 */

  getters: {
    getDetailParam: (state) => state.detailParam,
  },
  mutations: {
    SET_DETAIL_PARAM(state, param) {
      state.detailParam = param;
    },
  },
};
